import React, { FC } from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'

import { EuiLoadingContent, EuiPage, EuiPageBody, EuiPageHeader, EuiPageHeaderSection, EuiPanel, EuiSpacer, EuiText, EuiTitle } from '@elastic/eui'

import { RootState } from '../../app/rootReducer'

interface AgencyV2ClientPageLayoutProps {
  helmetTitle?: string
  panelTitle?: string
  panelDescription?: string
  boldPanelDescription?: boolean
  headerTitle?: JSX.Element | string
  headerDescription?: string
  children: React.ReactNode
  isLoading?: boolean
}

export const AgencyV2ClientPageLayout = ({ helmetTitle, panelTitle, panelDescription, boldPanelDescription, headerTitle, headerDescription, children, isLoading }: AgencyV2ClientPageLayoutProps) => {
  const { currentAccount } = useSelector((state: RootState) => state.app)

  return (
    <EuiPageBody>
      {helmetTitle && (
        <Helmet>
          <title>{helmetTitle}</title>
        </Helmet>
      )}
      <EuiPageHeader>
        <EuiPageHeaderSection>
          {!headerTitle && (
            <EuiTitle>
              <h1>Client: {currentAccount?.name}</h1>
            </EuiTitle>
          )}
          {typeof headerTitle !== 'string' && headerTitle}
          {typeof headerTitle === 'string' && (
            <EuiTitle>
              <h1>{headerTitle}</h1>
            </EuiTitle>
          )}
          {headerDescription && <EuiText>{headerDescription}</EuiText>}
        </EuiPageHeaderSection>
      </EuiPageHeader>
      <EuiPanel grow={false}>
        {isLoading ? (
          <EuiLoadingContent />
        ) : (
          <>
            {panelTitle && (
              <>
                <EuiTitle size={'s'}>
                  <h2>{panelTitle}</h2>
                </EuiTitle>
                {panelDescription && <EuiText size={'s'}>{boldPanelDescription ? <b>{panelDescription}</b> : panelDescription}</EuiText>}
                <EuiSpacer />
              </>
            )}
            {children}
          </>
        )}
      </EuiPanel>
    </EuiPageBody>
  )
}
